export const EXP_NUMERO = /^[0-9\b]+$/;
const EXP_DNI = /^[0-9\b]{8}$/;
const EXP_CELULAR = /^[9]{1}[0-9\b]{8}$/;
const EXP_FECHA_NAC = /^(0[1-9]|[12][0-9]|3[01])[- /.](?:(0[1-9]|1[012])[- /.](19|20)[0-9]{2})$/;
const EXP_CARNET_EXTRANJERIA = /^[a-zA-Z0-9\b]+$/;
const EXP_LETRAS_NUMEROS = /^[a-zA-Z0-9 áéíóúüñÑ]+$/;
export const DNI = 'L';
export const CE = 'E';
export const EXP_CORREO = /^[a-zA-Z0-9_-]+(?:\.[a-zA-Z0-9_-]+)*@\w+(\.\w{2,4})+$/;
export const KEYCODE_ENTER = 13;
export const PLD = 'PLD';
export const AUTO_NUEVO = 'AUTO_NUEVO';
export const AUTO_USADO = 'AUTO_USADO';
export const ESTUDIOS = 'ESTUDIOS';
export const HIPOTECARIO = 'HIPOTECARIO';

export const ERROR_GENERICO = '0000';
export const ERROR_RENIEC = '0400';
export const ERROR_ASO = '0091';
export const ERROR_LISTCUSTOMER = '0007';
export const ERROR_LISTA_NEGRA_SEGUROS = '0009';
export const ERROR_REINTENTOS_DNI = '0027';
export const ERROR_REINTENTOS_FECHA = '0029';
export const ERROR_VERIFICACION_PENDIENTE = '0030';
export const ERROR_FUERA_HORARIO = '0031';
export const ERROR_FATCA = '0308';
export const PERSONA_BLOQUEADA = '016';
export const MOTOR_RIESGO_ERROR = '400';
export const MOTOR_RIESGO_TIMEOUT = '401';
export const MOTOR_RIESGO_LISTA_NEGRA = '402';
export const MOTOR_RIESGO_OTROS = '409';
export const SEGURO_LISTA_NEGRA = '012';
export const MOTOR_OFERTA_LISTA_NEGRA_BURO = '403';
export const MOTOR_OFERTA_LISTA_NEGRA_ESTRATEGIA = '404';
export const MOTOR_OFERTA_LISTA_NEGRA_MOI = '405';
export const MOTOR_OFERTA_LISTA_NEGRA_SCORE = '406';
export const MOTOR_OFERTA_LISTA_NEGRA_VALIDACIONES = '407';
export const MOTOR_OFERTA_OTROS = '410';
export const MOTOR_EVALUACION_LISTA_NEGRA_PREDECISION = '408';
export const MOTOR_EVALUACION_OTROS = '411';
export const MOTOR_EVALUACION_RECHAZADO = '412';
export const PEP = '014';
export const INELEGIBLE = '999';
export const SIN_OFERTA_VEH_NUEVO = '010';
export const SIN_OFERTA_VEH_USADO = '011';
export const SIN_OFERTA_ESTUDIOS = '020';
export const CORREO_REPETIDO = '0024';
export const CELULAR_REPETIDO = '0025';
export const FECHA_INCORRECTA = '1005';
export const DIRECCION_NO_COINCIDE = '0419';
export const SMS_NO_COINCIDE = '0309';
export const EXCEDIO_INTENTO_SMS = '0310';
export const LIMITE_SOLICTAR_SMS = '0311';
export const ERROR_CONTRATACION = '0312';
export const UBIGEO_RENIEC_NO_EXISTE = '0410';
export const UBIGEO_RENIEC_INCOMPLETO = '600';
export const ERROR_LISTA_NEGRA_FORZADA = '601';
export const ERROR_LISTA_OFERTA_SINSEGURO = '1007';

export const HIPOTECARIO_ERROR_SERVICIO = '-999';
export const HIPOTECARIO_LISTA_NEGRA = 'H999';
export const PERSONA_FATCA_PEP = '0308_014';

export const PROFESIONES_SIN_EMPRESA = ['305', '230', 'OFI-2', 'OFI', '120-2', '120', '115', '315', '245', '300', 'IND'];
export const NO_APLICA = 'No aplica';

export const USD = 'USD';
export const PEN = 'PEN';
export const ID_PEN = '01';
export const ID_USD = '02';

export const PANTALLA_MOVIL = 768;
export const MONTO_INICIAL = 400000;
export const PORCENT_CUOTA_INICIAL = 10;
export const ANIOS_INICIAL = 15;

export const ERRORES = {
  [ERROR_GENERICO]: {descrip: 'error generico'},
  [ERROR_RENIEC]: {descrip: 'error reniec'},
  [ERROR_ASO]: {descrip: 'error aso'},
  [ERROR_LISTCUSTOMER]: {descrip: 'error list customer'},
  [ERROR_LISTA_NEGRA_SEGUROS]: {descrip: 'lista negra seguros error'},
  [ERROR_REINTENTOS_DNI]: {descrip: 'rechazado por limite ingresos'},
  [ERROR_REINTENTOS_FECHA]: {descrip: 'error fecha nacimiento'},
  [ERROR_VERIFICACION_PENDIENTE]: {descrip: 'no verificado'},
  [ERROR_FUERA_HORARIO]: {descrip: 'horario no disponible'},
  [ERROR_FATCA]: {descrip: 'fatca'},
  [PERSONA_BLOQUEADA]: {descrip: 'persona bloqueada'},
  [MOTOR_RIESGO_ERROR]: {descrip: 'error motor'},
  [MOTOR_RIESGO_TIMEOUT]: {descrip: 'error motor'},
  [MOTOR_RIESGO_LISTA_NEGRA]: {descrip: 'lista negra'},
  [MOTOR_RIESGO_OTROS]: {descrip: 'otros 1'},
  [SEGURO_LISTA_NEGRA]: {descrip: 'lista negra de seguros'},
  [MOTOR_OFERTA_LISTA_NEGRA_BURO]: {descrip: 'lista negra 2'},
  [MOTOR_OFERTA_LISTA_NEGRA_ESTRATEGIA]: {descrip: 'lista negra 2'},
  [MOTOR_OFERTA_LISTA_NEGRA_MOI]: {descrip: 'lista negra 2'},
  [MOTOR_OFERTA_LISTA_NEGRA_SCORE]: {descrip: 'lista negra 2'},
  [MOTOR_OFERTA_LISTA_NEGRA_VALIDACIONES]: {descrip: 'lista negra 2'},
  [MOTOR_OFERTA_OTROS]: {descrip: 'otros 2'},
  [MOTOR_EVALUACION_LISTA_NEGRA_PREDECISION]: {descrip: 'lista negra 3'},
  [MOTOR_EVALUACION_OTROS]: {descrip: 'otros 3'},
  [MOTOR_EVALUACION_RECHAZADO]: {descrip: 'rechazado'},
  [PEP]: {descrip: 'pep'},
  [INELEGIBLE]: {descrip: 'error inelegible'},
  [SIN_OFERTA_VEH_NUEVO]: {descrip: 'sin oferta'},
  [SIN_OFERTA_VEH_USADO]: {descrip: 'sin oferta'},
  [SIN_OFERTA_ESTUDIOS]: {descrip: 'sin oferta'},
  [CELULAR_REPETIDO]: {},
  [CORREO_REPETIDO]: {},
  [FECHA_INCORRECTA]: {},
  [DIRECCION_NO_COINCIDE]: {descrip: 'direccion no coincide con reniec'},
  [SMS_NO_COINCIDE]: {descrip: 'sms no coincide'},
  [EXCEDIO_INTENTO_SMS]: {descrip: 'error intentos clave sms'},
  [LIMITE_SOLICTAR_SMS]: {descrip: 'limite solicitar sms'},
  [ERROR_CONTRATACION]: {descrip: 'error contratacion'},
  [UBIGEO_RENIEC_NO_EXISTE]: {descrip: 'error sin ubigeo'},
  [UBIGEO_RENIEC_INCOMPLETO]: {descrip: 'error ubigeo incompleto'},
  [ERROR_LISTA_NEGRA_FORZADA]: {descrip: 'lista negra forzada'},
  [PERSONA_FATCA_PEP]: {descrip: 'pep y fatca'},
  [ERROR_LISTA_OFERTA_SINSEGURO]: {descrip: 'error listar ofertas sin seguro'},
};


export function autoScrollByElemento(event) {
  let element = event.currentTarget;
  scrollear(element);
}

export function autoScrollFirtsError() {
  setTimeout(() => {
    let firtsElementError = document.getElementsByClassName('input--error')[0];
    if (firtsElementError) scrollear(firtsElementError);
  }, 100);
}

let scrollear = function (element) {
  const isMobile = window.innerWidth <= 768;
  var margenBlanco = 15;
  var topElemento = element.getBoundingClientRect().top;
  var elementHeader = window.document.getElementById('idMainHeader');
  var stickyResumen = window.document.getElementById('sticky_resumen');
  var alturaHeader = elementHeader ? elementHeader.offsetHeight : 0;
  var alturaStickyRsm = isMobile ? (stickyResumen ? stickyResumen.offsetHeight : 0) : 0;

  var margen = Number(alturaHeader + alturaStickyRsm);
  var moverScroll = topElemento - margen;
  if (topElemento > margen + 1) {
    window.scrollBy(0, moverScroll - margenBlanco);
  }
};

export function scrollToTop() {
  window.scrollTo(0, 0);
}

export function inIframeReact() {
  return window.self !== window.top;
}

export function calcular_edad(fecNac) {
  var dia = fecNac.split('/')[0];
  var mes = fecNac.split('/')[1];
  var ano = fecNac.split('/')[2];
  let fecha_hoy = new Date();
  let ahora_ano = fecha_hoy.getYear();
  let ahora_mes = fecha_hoy.getMonth() + 1;
  let ahora_dia = fecha_hoy.getDate();

  // realizamos el calculo
  var edad = ahora_ano + 1900 - ano;
  if (ahora_mes < Number(mes)) {
    edad--;
  }
  if (Number(mes) === ahora_mes && ahora_dia < Number(dia)) {
    edad--;
  }
  if (edad > 1900) {
    edad -= 1900;
  }

  return edad;
}

export var soles = {
  symbol: 'S/ ',
  decimal: '.',
  thousand: ',',
  precision: 0,
  format: '%s%v',
};

export var dolares = {
  symbol: '$ ',
  decimal: '.',
  thousand: ',',
  precision: 0,
  format: '%s%v',
};

export function formatDecimal(num) {
  return Number.parseFloat(num).toFixed(2);
}

export function formatDecimalCustom(num, decimal) {
  return Number.parseFloat(num).toFixed(decimal);
}

export function obtenerMesActual() {
  return new Intl.DateTimeFormat('es-ES', {month: 'long'}).format(new Date());
}

export function obtenerUltimoDiaMes() {
  return new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate();
}

export function inicialMayuscula(texto) {
  return texto ? texto[0].toUpperCase() + texto.slice(1).toLowerCase() : texto;
}

export function primerNombre(texto) {
  return texto ? texto.split(' ')[0] : texto;
}

export function cortarString(str, longitud) {
  return str.length > longitud ? str.slice(0, longitud).trim() : str.trim();
}

export const datosCabecera = {
  'mes': 'Mes',
  'dia': 'Fecha de pago',
  'amortizacion': 'Capital',
  'interes': 'Interés',
  'seguro': 'Seguro desgravamen',
  'total': 'Total de cuota',
  'saldo': 'Saldo pendiente',
};

export function formatoContador(time) {
  let minutos = Math.floor(time / 60);
  let segundos = time % 60;
  return `${String(minutos).padStart(1, '0')}:${String(segundos).padStart(2, '0')}`;
}

export function formatoTelefono(telefono) {
  return telefono.substr(0, 3) + ' ' + telefono.substr(3, 3) + ' ' + telefono.substr(6, 3);
}

export function setearValueDiaPago(diaPago) {
  return {value: diaPago, label: diaPago + ' de cada mes'};
}

export function setearValuePlazo(plazo) {
  return {value: plazo, label: plazo + ' meses'};
}

export function isFormatoCodigoSMS(value) {
  return (value === '' || EXP_NUMERO.test(value)) && value.length < 7;
}

export function isFormatoCelular(value) {
  return (value === '' || EXP_NUMERO.test(value)) && value.length < 10;
}

export function isFormatoDni(value) {
  return (value === '' || EXP_NUMERO.test(value)) && value.length < 9;
}

export function isFormatoCE(value) {
  return (value === '' || EXP_CARNET_EXTRANJERIA.test(value)) && value.length < 13;
}

export function dniCorrecto(value) {
  return EXP_DNI.test(value);
}

export function CECorrecto(value) {
  return EXP_CARNET_EXTRANJERIA.test(value) && value.length < 13 && value.length > 8;
}

export function documentoCorrecto(tipo, value) {
  return tipo === CE ? CECorrecto(value) : dniCorrecto(value);
}

export function fechaCorrecta(value) {
  return EXP_FECHA_NAC.test(value);
}

export function celularCorrecto(value) {
  return EXP_CELULAR.test(value);
}

export function correoCorrecto(value) {
  return EXP_CORREO.test(value);
}

export function isFormatoNombre(value) {
  return (value === '' || EXP_LETRAS_NUMEROS.test(value)) && value.length < 50;
}

export function isFormatoApellido(value) {
  return (value === '' || EXP_LETRAS_NUMEROS.test(value)) && value.length < 100;
}

export function construirObjFinal(data) {
  const objFinal = {
    idSesion: data.idSesion,
    flujo: data.flujo,
    dataContratacion: data.dataContratacion,
    dataPersona: data.dataPersona,
  };
  return objFinal;
}

export function alturaHeader() {
  const valorArbitrario = 4;
  const alturaHeader = window.document.getElementById('root').offsetHeight + valorArbitrario;
  return window.innerHeight - alturaHeader;
}

export function formatoImporte(importe, decimal) {
  if (importe === null || importe === undefined) {
    return '';
  }
  const locale = 'en-US';
  const options = {};
  if (decimal !== undefined) {
    options.minimumFractionDigits = decimal;
    options.maximumFractionDigits = decimal;
  } else {
    options.minimumFractionDigits = 0;
    options.maximumFractionDigits = 0;
  }
  return importe.toLocaleString(locale, options);
}

export function formatoFecha(dateStr) {
  const months = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
  const [day, month, year] = dateStr.split('/');
  const monthName = months[parseInt(month) - 1];
  return `${day} ${monthName} ${year}`;
};
